import { each, chain, pick } from 'lodash';
import { useColumnSelect } from '@msrceng/component';
import { ISearchListColumn } from 'component/Search/IColumnExtensionType';

/** Gets a function that determines the visible items in a details itemlist
 * based on the currently selected columns, and removes duplicates.
 */

export const useColumnSelectToGetDistinctItemList = (): ((
  itemList: any[]
) => any[]) => {
  const { selectedColumnList } = useColumnSelect<ISearchListColumn>();
  const testKeyList: string[] = [];
  each(selectedColumnList, c => {
    testKeyList.push(c.key);
    c.fieldName && testKeyList.push(c.fieldName);
  });
  return itemList =>
    chain(itemList)
      .map(item => {
        //generate an object that carries both the original and the test output
        const testValue = JSON.stringify(pick(item, testKeyList));
        return { item, testValue };
      })
      .uniqBy(item => item.testValue) //remove duplicates
      .map(i => i.item) //return just the regular items
      .value();
};
